var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.sizePx}},[_c('img',{attrs:{"width":_vm.sizeInternal,"height":_vm.sizeInternal,"alt":"imagem de perfil","title":"imagem de perfil","src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }